import { c as _c } from "react/compiler-runtime";
import { cn } from '@sola/ark-core/utils/helpers.ts';
import type { ComponentBaseProps, FlexibleContentProps } from '@sola/schema/lib/schema.ts';
import { FeatureBase } from '../../../molecules/feature-base/feature-base.tsx';
import { HeaderGroup } from '../../../molecules/header-group/header-group.tsx';
import { getBaseSizeProps } from '../../../utils/text-utils.tsx';
export type BasicContentProps = FlexibleContentProps & ComponentBaseProps;
export const BasicContentSolo: React.FC<BasicContentProps> = t0 => {
  const $ = _c(25);
  let alt;
  let inline;
  let props;
  let settings;
  let t1;
  if ($[0] !== t0) {
    const {
      seoLevel: t2,
      media: _media,
      quotation: _quotation,
      alt: t3,
      inline: t4,
      settings: t5,
      ...t6
    } = t0;
    t1 = t2;
    alt = t3;
    inline = t4;
    settings = t5;
    props = t6;
    $[0] = t0;
    $[1] = alt;
    $[2] = inline;
    $[3] = props;
    $[4] = settings;
    $[5] = t1;
  } else {
    alt = $[1];
    inline = $[2];
    props = $[3];
    settings = $[4];
    t1 = $[5];
  }
  const seoLevel = t1 === undefined ? 2 : t1;
  const hasHeaderGroup = !alt;
  const t2 = settings?.themeOverride ? `${settings.themeOverride}-themeOverride` : "";
  let t3;
  if ($[6] !== t2) {
    t3 = cn("BasicContentSolo component component--container", t2);
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== hasHeaderGroup || $[9] !== inline || $[10] !== props || $[11] !== seoLevel) {
    t4 = hasHeaderGroup && <HeaderGroup {...props} {...getBaseSizeProps(seoLevel, inline)} seoLevel={seoLevel} />;
    $[8] = hasHeaderGroup;
    $[9] = inline;
    $[10] = props;
    $[11] = seoLevel;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== alt || $[14] !== hasHeaderGroup || $[15] !== inline || $[16] !== props || $[17] !== seoLevel) {
    t5 = !hasHeaderGroup && <div className="w-full max-w-md mx-auto"><FeatureBase {...props} {...getBaseSizeProps(seoLevel, inline)} seoLevel={seoLevel} variant={alt ? "centered" : "standard"} inline={true} /></div>;
    $[13] = alt;
    $[14] = hasHeaderGroup;
    $[15] = inline;
    $[16] = props;
    $[17] = seoLevel;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] !== t4 || $[20] !== t5) {
    t6 = <div className="container container--inline-box">{t4}{t5}</div>;
    $[19] = t4;
    $[20] = t5;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  let t7;
  if ($[22] !== t3 || $[23] !== t6) {
    t7 = <section className={t3}>{t6}</section>;
    $[22] = t3;
    $[23] = t6;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  return t7;
};